<ng-container *ngIf="displayModal">
    <div class="modal" (click)="onClickOutside($event)">
        <div class="modal__container">
            <h3 class="modal__title" [ngClass]="checkVersion">
                <ng-content select=".modal-title"></ng-content>
                <ng-container *ngIf="version === 'v2'">
                    <button type="button" (click)="close()">
                        <img src="../../../../assets/images/ic_baseline-close.svg">
                    </button>
                </ng-container>                
            </h3>
            <div class="modal__body"><ng-content select=".modal-content"></ng-content></div>
            <div class="modal__footer">
                <ng-container *ngIf="version === 'v1'">
                    <button class="button transparent" (click)="close()">Cancel</button>
                </ng-container>
                <ng-content select=".modal-footer"></ng-content>
            </div>
        </div>
    </div>    
</ng-container>
